import { Button, Col, Container, Modal, Row } from 'react-bootstrap';

import CloseButton from '../Styled/CloseButton';
import ReactMarkdown from 'react-markdown';
import { contentfulPropTypes } from '../../propTypes';
import logo from '../../assets/svg/loop-logo-black.svg';
import loopPhone from '../../assets/svg/loop-phone.svg';
import withContentfulTag from '../../utils/withContentfulTag';

const WelcomeModal = ({
  contentful,
  error,
  loading,
  fetched,
  showWelcome,
  onHideWelcome,
  navigate,
}) => (
  <Modal
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
    show={showWelcome}
    onHide={onHideWelcome}
    className="welcome">
    <Modal.Header>
      <CloseButton onClick={onHideWelcome} variant={'bordered'} />
    </Modal.Header>
    <Modal.Body className="pt-0">
      {!loading && fetched && (
        <Container fluid>
          <Row>
            <Col lg={5} className="pb-lg-4 pb-md-0">
              <img
                className="d-none d-lg-inline"
                src={loopPhone}
                alt="Phone graphic"
              />
            </Col>
            <Col className="text-center pl-lg-5 pl-md-0 ml-lg-5 ml-md-2 d-flex flex-column justify-content-between">
              <div>
                <img src={logo} alt="Loop Energy" />
                <h1 className="py-4">{contentful?.title}</h1>
                <ReactMarkdown>{contentful?.body}</ReactMarkdown>
              </div>
              <div className={'pb-4'}>
                <Row>
                  <Col>
                    <Button
                      variant="primary"
                      className="w-100"
                      onClick={() => navigate('/download')}>
                      {contentful?.primaryButtonText}
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      variant="secondary"
                      className="w-100"
                      onClick={onHideWelcome}>
                      {contentful?.secondaryButtonText}
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </Modal.Body>
  </Modal>
);

WelcomeModal.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(WelcomeModal, 'web_app_welcome_modal');
